<ng-container *ngIf="_barcodeLabelServices.productDetailPrintBarcodeLabel">
    <p-dialog
        header="Barcode Printing"
        [(visible)]="_barcodeLabelServices.productDetailPrintBarcodeLabel"
        [style]="{ width: '70%' }"
        modal="true"
    >
        <app-barcode-label-printing-form
            *ngIf="_barcodeLabelServices.productDetailPrintBarcodeLabel"
            [isNew]="true"
            [fromList]="false"
            [isProductLabel]="true"
        ></app-barcode-label-printing-form>
    </p-dialog>
</ng-container>

<p-toolbar class="product-toolbar border-200">
    <div class="p-toolbar-group-left">
        <div class="toolbar-title">
            <ng-container *ngIf="_productService.isViewOnly; else editOrNew">
                View Product
            </ng-container>
            <ng-template #editOrNew>
                <h5>
                    {{ _productService.isNew ? "Add Product" : "Edit Product" }}
                </h5>
            </ng-template>
        </div>
    </div>
    <div class="p-toolbar-group-right" *ngIf="!_productService.isViewOnly">
        <p-splitButton
            label="Save"
            icon="pi pi-check"
            [model]="saveMenuItemsStateful"
            appendTo="body"
            menuStyleClass="save-split-menu"
            (onClick)="saveProductClick('save-only')"
            pTooltip="Complete the required fields to enable saving"
            [tooltipDisabled]="!isSaveDisabled"
            tooltipPosition="bottom"
            [styleClass]="
                'save-split ' + (isSaveDisabled ? 'save-main-disabled' : '')
            "
        ></p-splitButton>
    </div>
    <div
        class="p-toolbar-group-right toolbar-actions inline-actions"
        *ngIf="_productService.isViewOnly && !isEmbeddedView"
    >
        <button
            pButton
            type="button"
            class="p-button-secondary"
            (click)="cancelClick()"
        >
            <i class="pi pi-times me-1"></i>
            Close
        </button>
    </div>
</p-toolbar>

<div class="grid product-main-grid">
    <div class="col-12 xxl:col-8 lg:col-7 md:col-12 sm:col-12 overflow-hidden">
        <div class="card-block">
            <app-product-details
                #productDetails
                [showUrlSection]="false"
            ></app-product-details>

            <div class="grid category-price-row">
                <div class="col-12 sm:col-4 md:col-4 field category-field">
                    <label class="control-label">
                        <strong>Category</strong>
                    </label>
                    <p-dropdown
                        [style]="{ width: '100%' }"
                        class="p-dropdown-1"
                        appendTo="body"
                        [options]="categoryOptions$ | async"
                        [(ngModel)]="_abd.selectedCategory"
                        [group]="true"
                        optionLabel="categoryName"
                        optionGroupLabel="label"
                        optionGroupChildren="items"
                        [filter]="true"
                        filterBy="categoryName"
                        [disabled]="_productService.isViewOnly"
                        (onChange)="onCategoryChanged($event)"
                    >
                        <ng-template pTemplate="group" let-group>
                            <span class="font-semibold">{{ group.label }}</span>
                        </ng-template>
                        <ng-template let-category pTemplate="selectedItem">
                            <div class="category-option">
                                <span class="category-option-img-wrap">
                                    <img
                                        *ngIf="category.image"
                                        [src]="category.image"
                                        class="category-option-img"
                                        alt="Category image"
                                        (error)="
                                            $event.target.style.display = 'none';
                                            $event.target.nextElementSibling.style.display = 'flex'
                                        "
                                    />
                                    <span
                                        class="category-option-img-fallback"
                                        [style.display]="category.image ? 'none' : 'flex'"
                                    >
                                        <i class="pi pi-image"></i>
                                    </span>
                                </span>
                                <span>{{ category.categoryName }}</span>
                            </div>
                        </ng-template>
                        <ng-template let-category pTemplate="item">
                            <div class="category-option" [style.padding-left.rem]="category.parent ? 1.5 : null">
                                <span class="category-option-img-wrap">
                                    <img
                                        *ngIf="category.image"
                                        [src]="category.image"
                                        class="category-option-img"
                                        alt="Category image"
                                        (error)="
                                            $event.target.style.display = 'none';
                                            $event.target.nextElementSibling.style.display = 'flex'
                                        "
                                    />
                                    <span
                                        class="category-option-img-fallback"
                                        [style.display]="category.image ? 'none' : 'flex'"
                                    >
                                        <i class="pi pi-image"></i>
                                    </span>
                                </span>
                                <span>{{ category.categoryName }}</span>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <button
                                pButton
                                type="button"
                                class="link-btn-alternate w-100"
                                (click)="addCategory()"
                                [disabled]="_productService.isViewOnly"
                            >
                                <i class="pi pi-plus me-1"></i>
                                Add Category
                            </button>
                        </ng-template>
                    </p-dropdown>
                </div>
                <div class="col-12 sm:col-4 md:col-4 field category-field">
                    <label class="control-label">
                        <strong>Price A<span class="required">*</span></strong>
                    </label>
                    <div class="price-wrapper">
                        <span class="price-prefix">{{ "" | currency | currencySymbol }}</span>
                        <p-inputNumber
                            class="price-input"
                            [ngModel]="_productService.pts.priceA"
                            (ngModelChange)="onQuickPriceChange($event)"
                            (onBlur)="onQuickPriceBlur()"
                            (onFocus)="onZeroValueFocus('priceA', $event)"
                            [disabled]="_productService.isViewOnly"
                            mode="decimal"
                            [format]="true"
                            [useGrouping]="true"
                            [min]="0"
                            [max]="100000"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            placeholder="0.00"
                        ></p-inputNumber>
                    </div>
                </div>
                <div class="col-12 sm:col-4 md:col-4 field category-field">
                    <label class="control-label">
                        <strong
                            >Cost Price <span class="required">*</span></strong
                        >
                    </label>
                    <div class="price-wrapper">
                        <span class="price-prefix">{{ "" | currency | currencySymbol }}</span>
                        <p-inputNumber
                            class="price-input"
                            [ngModel]="_productService.pts.costPrice"
                            (ngModelChange)="onQuickCostChange($event)"
                            (onBlur)="onQuickCostBlur()"
                            (onFocus)="onZeroValueFocus('costPrice', $event)"
                            [disabled]="_productService.isViewOnly"
                            mode="decimal"
                            [format]="true"
                            [useGrouping]="true"
                            [min]="0"
                            [max]="100000"
                            [minFractionDigits]="2"
                            [maxFractionDigits]="2"
                            placeholder="0.00"
                        ></p-inputNumber>
                    </div>
                </div>
            </div>

            <div class="gallery-inline top-spacing">
                <div class="card-title gallery-title">
                    <span>Gallery Images</span>
                    <!-- <span class="gallery-count">image(s) {{ _productService.thImages.length }} of 10</span> -->
                </div>
                <div class="fadeinright animation-duration-200">
                    <app-image-multi-v2
                        style="width: 100%"
                    ></app-image-multi-v2>
                </div>
            </div>

            <div
                class="url-block"
                *ngIf="
                    productDetails.url ||
                    productDetails.cartUrl ||
                    productDetails.isUrlLoad ||
                    (!_productService.isNew &&
                        _globals.webStoreConfiguration?.webStoreHost)
                "
            >
                <div
                    class="url-row"
                    *ngIf="productDetails.isAiEditorUrls && variantLinkOptions.length"
                >
                    <div class="card-title mb-2">Link for</div>
                    <p-dropdown
                        [options]="variantLinkOptions"
                        optionLabel="label"
                        optionValue="value"
                        [(ngModel)]="selectedVariantLink"
                        [style]="{ minWidth: '14rem' }"
                        appendTo="body"
                    ></p-dropdown>
                </div>

                <div class="url-row">
                    <div class="card-title mb-2">Product URL</div>
                    <div class="url-actions">
                        <ng-container *ngIf="productDetails.isUrlLoad">
                            <i
                                class="pi pi-spin pi-spinner"
                                style="
                                    color: var(--brandColor);
                                    font-size: large;
                                "
                            ></i>
                        </ng-container>
                        <ng-container *ngIf="!productDetails.isUrlLoad">
                            <div
                                class="url-text"
                                *ngIf="productDetails.url; else urlPlaceholder"
                            >
                                {{ productDetails.isAiEditorUrls ? getLinkUrl(productDetails.url) : productDetails.url }}
                                <i
                                    class="pi pi-copy cursor-pointer"
                                    style="color: var(--brandColor)"
                                    (click)="
                                        productDetails.copy(productDetails.isAiEditorUrls ? getLinkUrl(productDetails.url) : productDetails.url)
                                    "
                                ></i>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="url-row">
                    <div class="card-title mt-3 mb-2">Product add to cart</div>
                    <div class="url-actions">
                        <ng-container *ngIf="productDetails.isUrlLoad">
                            <i
                                class="pi pi-spin pi-spinner"
                                style="
                                    color: var(--brandColor);
                                    font-size: large;
                                "
                            ></i>
                        </ng-container>
                        <ng-container *ngIf="!productDetails.isUrlLoad">
                            <div
                                class="url-text"
                                *ngIf="
                                    productDetails.cartUrl;
                                    else cartPlaceholder
                                "
                            >
                                {{ productDetails.isAiEditorUrls ? getLinkCartUrl(productDetails.url) : productDetails.cartUrl }}
                                <i
                                    class="pi pi-copy cursor-pointer"
                                    style="color: var(--brandColor)"
                                    (click)="
                                        productDetails.copy(
                                            productDetails.isAiEditorUrls ? getLinkCartUrl(productDetails.url) : productDetails.cartUrl
                                        )
                                    "
                                ></i>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <ng-template #urlPlaceholder>
                    <span class="placeholder-text"
                        >Will appear after product is created.</span
                    >
                </ng-template>
                <ng-template #cartPlaceholder>
                    <span class="placeholder-text"
                        >Will appear after product is created.</span
                    >
                </ng-template>
            </div>
        </div>
        <div class="card-block top-spacing" [hidden]="isQuickMode" *ngIf="isVariantsFeatureEnabled && !shouldHideVariantsForCurrentUser">
            <app-product-variants
                [enableVariantCost]="true"
                (baseCostDerived)="onQuickCostChange($event)"
            ></app-product-variants>
        </div>
        <div class="accordion-inline-alert" [hidden]="isQuickMode" *ngIf="hasAdditionalDetailsError">
            <i class="pi pi-info-circle"></i>
            Please fix the required fields in Inventory or Pricing below.
        </div>
        <div class="card-block p-0 top-spacing" [hidden]="isQuickMode">
            <p-accordion
                [multiple]="false"
                [activeIndex]="-1"
                class="additional-accordion"
                expandIcon="pi pi-chevron-down"
                collapseIcon="pi pi-chevron-up"
            >
                <p-accordionTab
                    (onClose)="onAdditionalDetailsClose()"
                    (onOpen)="onAdditionalDetailsOpen()"
                >
                    <ng-template pTemplate="header">
                        <div class="accordion-header">
                            <span>Additional Details</span>
                        </div>
                    </ng-template>
                    <p-accordion
                        [multiple]="false"
                        class="additional-accordion nested"
                        expandIcon="pi pi-chevron-down"
                        collapseIcon="pi pi-chevron-up"
                    >
                        <p-accordionTab header="Properties">
                            <app-product-general-properties></app-product-general-properties>
                        </p-accordionTab>
                        <p-accordionTab
                            header="Inventory"
                            (onClose)="onInventoryTabClose()"
                            (onOpen)="onInventoryTabOpen()"
                        >
                            <ng-template pTemplate="header">
                                <div
                                    class="accordion-header"
                                    [ngClass]="{
                                        'accordion-header-error':
                                            inventorySectionError
                                    }"
                                >
                                    <span
                                        class="accordion-error-chip"
                                        *ngIf="inventorySectionError"
                                        >Fix required</span
                                    >
                                </div>
                            </ng-template>
                            <app-product-inventory></app-product-inventory>
                        </p-accordionTab>
                        <p-accordionTab header="Stock Management">
                            <app-product-stock-management-v2></app-product-stock-management-v2>
                        </p-accordionTab>
                        <!-- <p-accordionTab header="Product Organization" class="mobile-only">
                <ng-container ></ng-container>
              </p-accordionTab> -->
                        <p-accordionTab
                            header="Pricing"
                            (onClose)="onPricingTabClose()"
                            (onOpen)="onPricingTabOpen()"
                        >
                            <app-product-pricing-v2></app-product-pricing-v2>
                        </p-accordionTab>
                        <p-accordionTab header="Shipping Information" *ngIf="!hasVariants">
                            <app-product-shipping-info></app-product-shipping-info>
                        </p-accordionTab>
                        <p-accordionTab
                            header="Additional"
                            *ngIf="!isFreeTrialPlan"
                        >
                            <app-product-notes></app-product-notes>
                        </p-accordionTab>
                        <p-accordionTab
                            header="Print Label"
                            *ngIf="isNew && !isFreeTrialPlan"
                        >
                            <div class="grid">
                                <div class="col-12 md:col-8">
                                    <div class="grid form-grid">
                                        <div class="col-12 md:col-6">
                                            <label class="control-label">
                                                <strong
                                                    >Printer Brand
                                                    <span class="required"
                                                        >*</span
                                                    ></strong
                                                >
                                            </label>
                                            <p-dropdown
                                                [(ngModel)]="selectedBrand"
                                                class="p-dropdown-1"
                                                [options]="configuration"
                                                optionLabel="brandName"
                                                [autoDisplayFirst]="true"
                                                [style]="{
                                                    width: '100%',
                                                    'margin-top': '8px'
                                                }"
                                            ></p-dropdown>
                                        </div>
                                        <div class="col-12 md:col-6">
                                            <label class="control-label">
                                                <strong
                                                    >Label Size
                                                    <span class="required"
                                                        >*</span
                                                    ></strong
                                                >
                                            </label>
                                            <p-dropdown
                                                [(ngModel)]="selectedlabelSizes"
                                                class="p-dropdown-1"
                                                [options]="
                                                    selectedBrand?.labelSizes
                                                "
                                                optionLabel="name"
                                                [autoDisplayFirst]="true"
                                                [style]="{
                                                    width: '100%',
                                                    'margin-top': '8px'
                                                }"
                                            ></p-dropdown>
                                        </div>
                                        <div class="col-12 md:col-6">
                                            <label class="control-label">
                                                <strong
                                                    >Label Style
                                                    <span class="required"
                                                        >*</span
                                                    ></strong
                                                >
                                            </label>
                                            <p-dropdown
                                                [(ngModel)]="selectedlabelStyle"
                                                class="p-dropdown-1"
                                                [options]="
                                                    selectedlabelSizes?.style
                                                "
                                                optionLabel="name"
                                                [autoDisplayFirst]="true"
                                                [style]="{
                                                    width: '100%',
                                                    'margin-top': '8px'
                                                }"
                                            ></p-dropdown>
                                            <div
                                                class="label-box mt-3"
                                                [ngStyle]="{
                                                    'background-image':
                                                        'url(' +
                                                        selectedlabelStyle?.image +
                                                        ')'
                                                }"
                                            ></div>
                                        </div>
                                        <div class="col-12">
                                            <form
                                                [formGroup]="labelForm"
                                                autocomplete="off"
                                            >
                                                <div class="grid form-grid">
                                                    <div
                                                        class="col-12 md:col-6"
                                                    >
                                                        <label
                                                            class="control-label"
                                                        >
                                                            <strong
                                                                >Location</strong
                                                            >
                                                        </label>
                                                        <p-dropdown
                                                            [formControl]="
                                                                $any(
                                                                    labelForm.controls
                                                                )['location']
                                                            "
                                                            class="p-dropdown-1"
                                                            [options]="
                                                                _abd.locations
                                                            "
                                                            optionLabel="locationName"
                                                            [autoDisplayFirst]="
                                                                false
                                                            "
                                                            [style]="{
                                                                width: '100%',
                                                                'margin-top':
                                                                    '8px'
                                                            }"
                                                        ></p-dropdown>
                                                        <span
                                                            class="control-description text-muted"
                                                            >This location will
                                                            be printed on the
                                                            label.</span
                                                        >
                                                        <div
                                                            *ngIf="
                                                                $any(
                                                                    labelForm.controls
                                                                )['location']
                                                                    .invalid &&
                                                                $any(
                                                                    labelForm.controls
                                                                )['location']
                                                                    .touched
                                                            "
                                                            class="invalid-feedback"
                                                        >
                                                            Please Select a
                                                            Location
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-12 md:col-6"
                                                    >
                                                        <label
                                                            class="control-label"
                                                        >
                                                            <strong
                                                                >Printer
                                                                Locations</strong
                                                            >
                                                        </label>
                                                        <p-multiSelect
                                                            [formControl]="
                                                                $any(
                                                                    labelForm.controls
                                                                )['locations']
                                                            "
                                                            [style]="{
                                                                width: '100%'
                                                            }"
                                                            [options]="
                                                                _abd.locations
                                                            "
                                                            optionLabel="locationName"
                                                            [filter]="false"
                                                            appendTo="body"
                                                            [showToggleAll]="
                                                                true
                                                            "
                                                        >
                                                            <ng-template
                                                                pTemplate="header"
                                                            >
                                                                <div
                                                                    class="checkbox-all-text"
                                                                >
                                                                    Select All
                                                                </div>
                                                            </ng-template>
                                                        </p-multiSelect>
                                                        <div
                                                            *ngIf="
                                                                $any(
                                                                    labelForm.controls
                                                                )['locations']
                                                                    .invalid &&
                                                                $any(
                                                                    labelForm.controls
                                                                )['locations']
                                                                    .touched
                                                            "
                                                            class="invalid-feedback"
                                                        >
                                                            Please enter a
                                                            Location
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-12 md:col-6"
                                                    >
                                                        <label
                                                            class="control-label"
                                                        >
                                                            <strong
                                                                >No of Labels to
                                                                print
                                                                <span
                                                                    class="required"
                                                                    >*</span
                                                                ></strong
                                                            >
                                                        </label>
                                                        <app-text-input
                                                            [formControl]="
                                                                $any(
                                                                    labelForm.controls
                                                                )['noOfCopy']
                                                            "
                                                            [name]="
                                                                'No of Labels to print'
                                                            "
                                                            [label]="''"
                                                        >
                                                        </app-text-input>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 md:col-4">
                                    <div
                                        class="printer-pic"
                                        [ngStyle]="{
                                            'background-image':
                                                'url(' +
                                                selectedBrand?.image +
                                                ')'
                                        }"
                                    ></div>
                                    <div
                                        *ngIf="
                                            selectedlabelStyle?.name ===
                                                'Barcode - with Logo' ||
                                            selectedlabelStyle?.name ===
                                                'Barcode - with Logo - up'
                                        "
                                        class="conn-card py-1 logo-upload-card"
                                    >
                                        <label class="control-label py-1">
                                            <strong
                                                >Logo Image
                                                <span class="required"
                                                    >*</span
                                                ></strong
                                            >
                                        </label>
                                        <div
                                            class="flex justify-content-center flex-wrap"
                                        >
                                            <app-image-upload
                                                [imageData]="tempImageUrl"
                                                [dummyImageData]="
                                                    dummyImageData
                                                "
                                                class="img-box"
                                            ></app-image-upload>
                                            <span
                                                class="text-muted fs-7 text-align-center"
                                            >
                                                Set the Label Logo image. Only
                                                png, jpg, webP, and jpeg image
                                                files are accepted
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab>
                        <p-accordionTab
                            header="Print Label"
                            *ngIf="!isNew && !isFreeTrialPlan"
                        >
                            <span class="text-muted"
                                >Print label is available when creating a new
                                product.</span
                            >
                        </p-accordionTab>
                    </p-accordion>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>

    <div class="col-12 xxl:col-4 lg:col-5 md:col-12 sm:col-12">
        <div class="card-block side-card">
            <div class="card-title">Where to Sell</div>
            <ng-container *ngIf="!canSellOnline || !canSellInStore; else sellSelector">
                <div class="sell-tags">
                    <span class="sell-tag online" *ngIf="canSellOnline">Online</span>
                    <span class="sell-tag offline" *ngIf="canSellInStore">In-store</span>
                </div>
                <span class="control-description text-muted" *ngIf="canSellOnline && !canSellInStore">
                    Your plan allows selling online only.
                </span>
                <span class="control-description text-muted" *ngIf="!canSellOnline && canSellInStore">
                    Your plan allows selling in-store only.
                </span>
                <div class="control-description p-2 mt-2 border-round" style="background:#fff4e5;color:#7a4a00;" *ngIf="disabledSavedSellTypeLabel">
                    This product was saved as <strong>{{ disabledSavedSellTypeLabel }}</strong>, which is no longer
                    available on your plan.
                </div>
            </ng-container>
            <ng-template #sellSelector>
                <p-multiSelect
                    [style]="{ width: '100%' }"
                    display="chip"
                    [options]="sellChipOptions"
                    optionLabel="label"
                    optionValue="value"
                    [(ngModel)]="selectedSellChips"
                    (onChange)="onSellChipsChange($event.value)"
                    [showClear]="true"
                    [disabled]="_productService.isViewOnly"
                    [defaultLabel]="'Select channel(s)'"
                ></p-multiSelect>
                <span class="control-description text-muted">
                    By default, both in-store and online are selected unless the
                    plan restricts it.
                </span>
            </ng-template>
        </div>

        <div class="card-block side-card p-0 top-spacing" [hidden]="isQuickMode">
            <p-accordion
                [multiple]="false"
                [activeIndex]="-1"
                class="side-accordion"
                expandIcon="pi pi-chevron-down"
                collapseIcon="pi pi-chevron-up"
            >
                <p-accordionTab header="Product Organization">
                    <p-accordion
                        [multiple]="false"
                        class="side-accordion"
                        expandIcon="pi pi-chevron-down"
                        collapseIcon="pi pi-chevron-up"
                    >
                        <p-accordionTab
                            header="Department"
                            *ngxPermissionsOnly="['2028']"
                        >
                            <div class="dropdown-action-row">
                                <p-dropdown
                                    [style]="{ width: '100%' }"
                                    class="p-dropdown-1"
                                    appendTo="body"
                                    [options]="_abd.departmentsBS$ | async"
                                    [(ngModel)]="_abd.selectedDepartment"
                                    optionLabel="departmentName"
                                    [filter]="true"
                                    filterBy="departmentName"
                                    (onChange)="departmentChanged($event)"
                                    [disabled]="_productService.isViewOnly"
                                    [style]="{ width: '100%' }"
                                >
                                    <ng-template pTemplate="footer">
                                        <button
                                            pButton
                                            type="button"
                                            class="link-btn-alternate w-100"
                                            (click)="newDepartClick()"
                                            [disabled]="
                                                _productService.isViewOnly
                                            "
                                        >
                                            <i class="pi pi-plus me-1"></i>
                                            Add Department
                                        </button>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </p-accordionTab>

                        <p-accordionTab
                            header="Manufacturer"
                            *ngxPermissionsOnly="['2029']"
                        >
                            <div class="dropdown-action-row">
                                <p-dropdown
                                    [style]="{ width: '100%' }"
                                    class="p-dropdown-1"
                                    appendTo="body"
                                    [options]="_abd.manufacturer$ | async"
                                    [(ngModel)]="_abd.selectedManufacturer"
                                    optionLabel="manufacturerName"
                                    [filter]="true"
                                    filterBy="manufacturerName"
                                    [disabled]="_productService.isViewOnly"
                                    [style]="{ width: '100%' }"
                                >
                                    <ng-template pTemplate="footer">
                                        <button
                                            pButton
                                            type="button"
                                            class="link-btn-alternate w-100"
                                            (click)="
                                                _productService.isNewManufacturer = true
                                            "
                                            [disabled]="
                                                _productService.isViewOnly
                                            "
                                        >
                                            <i class="pi pi-plus me-1"></i>
                                            Add Manufacturer
                                        </button>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </p-accordionTab>

                        <p-accordionTab
                            header="Vendor"
                            *ngxPermissionsOnly="['2030']"
                        >
                            <div class="dropdown-action-row w-100">
                                <p-dropdown
                                    [style]="{ width: '100%' }"
                                    class="p-dropdown-1"
                                    appendTo="body"
                                    [options]="_abd.vendorsBS$ | async"
                                    [(ngModel)]="_abd.selectedVendor"
                                    optionLabel="vendorName"
                                    [filter]="true"
                                    filterBy="vendorName"
                                    [disabled]="_productService.isViewOnly"
                                    [style]="{ width: '100%' }"
                                >
                                    <ng-template pTemplate="footer">
                                        <button
                                            pButton
                                            type="button"
                                            class="link-btn-alternate w-100"
                                            (click)="
                                                _productService.isNewVendor = true
                                            "
                                            [disabled]="
                                                _productService.isViewOnly
                                            "
                                        >
                                            <i class="pi pi-plus me-1"></i>
                                            Add Vendor
                                        </button>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </p-accordionTab>

                        <p-accordionTab header="Alternate Codes">
                            <div [formGroup]="tagsForm">
                                <div class="sub-widget-w-margin-10">
                                    <label class="control-label"
                                        ><strong
                                            >Alternate Barcodes</strong
                                        ></label
                                    >
                                    <p-chips
                                        type="text"
                                        separator=","
                                        addOnBlur="true"
                                        [allowDuplicate]="true"
                                        formControlName="altBarcodes"
                                    >
                                    </p-chips>
                                    <span class="control-description text-muted"
                                        >Only unique barcodes are allowed.</span
                                    >
                                    <div
                                        class="invalid-feedback"
                                        *ngIf="
                                            tF.altBarcodes?.hasError(
                                                'duplicates'
                                            )
                                        "
                                    >
                                        <div>
                                            Duplicate values are not allowed.
                                            Please enter unique values.
                                        </div>
                                    </div>
                                </div>

                                <div class="sub-widget-w-margin-10">
                                    <label class="control-label"
                                        ><strong>Alternate SKUs</strong></label
                                    >
                                    <p-chips
                                        type="text"
                                        separator=","
                                        addOnBlur="true"
                                        [allowDuplicate]="true"
                                        formControlName="altSKUs"
                                    >
                                    </p-chips>
                                    <span class="control-description text-muted"
                                        >Only unique skus are allowed.</span
                                    >
                                    <div
                                        class="invalid-feedback"
                                        *ngIf="
                                            tF.altSKUs?.hasError('duplicates')
                                        "
                                    >
                                        <div>
                                            Duplicate values are not allowed.
                                            Please enter unique values.
                                        </div>
                                    </div>
                                </div>

                                <div class="sub-widget-w-margin-10">
                                    <label class="control-label"
                                        ><strong>Tags</strong></label
                                    >
                                    <p-chips
                                        type="text"
                                        separator=","
                                        addOnBlur="true"
                                        [allowDuplicate]="true"
                                        formControlName="altTags"
                                    >
                                    </p-chips>
                                    <span class="control-description text-muted"
                                        >Only unique tags are allowed.</span
                                    >
                                    <div
                                        class="invalid-feedback"
                                        *ngIf="
                                            tF.altTags?.hasError('duplicates')
                                        "
                                    >
                                        <div>
                                            Duplicate values are not allowed.
                                            Please enter unique values.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab>
                    </p-accordion>
                </p-accordionTab>
            </p-accordion>
        </div>
    </div>

</div>

<p-dialog
    *ngIf="_productService.isNewDepartment"
    header="New Department"
    [(visible)]="_productService.isNewDepartment"
    modal="true"
>
    <app-new-edit-department></app-new-edit-department>
</p-dialog>

<p-dialog
    *ngIf="_productService.isNewCategory"
    header="New Category"
    [(visible)]="_productService.isNewCategory"
    modal="true"
>
    <app-new-edit-category></app-new-edit-category>
</p-dialog>

<p-dialog
    *ngIf="_productService.isNewManufacturer"
    header="New Manufacturer"
    [(visible)]="_productService.isNewManufacturer"
    modal="true"
>
    <app-new-edit-manufacturer></app-new-edit-manufacturer>
</p-dialog>

<p-dialog
    *ngIf="_productService.isNewVendor"
    header="New Vendors"
    [(visible)]="_productService.isNewVendor"
    modal="true"
>
    <app-new-edit-vendor [isNew]="true"></app-new-edit-vendor>
</p-dialog>

